import React from 'react';
import { Tag } from '@zillow/constellation-10';
import { useSelectCurrentOrder } from '../../../../../selectors/order/selectCurrentOrder';

export const ZimTag: React.FC = () => {
  const { data: orderDetails } = useSelectCurrentOrder();
  if (!orderDetails.isZimConversationCreated) {
    return null;
  }
  return <Tag tone={'info'}>ZIM Active</Tag>;
};
